import PoliticalDocuments from "../PoliticalDocuments";
import PoliticalPartyInfo from "../PoliticalPartyInfo";



export default function(){

    return (<>
    <div className="card">
    <PoliticalDocuments header={"Documents"}/>
    </div>
    </>)
}